import React from "react";
import TextInput from "../../common/text-input/index.js";
import Text from "../../common/typography/text.js";
import DatePickerComponent from "../../common/date-picker/index.js";

const InvoiceProductDetailsSection = ({
  orderType,
  serializedProducts = [],
  nonSerializedProducts = [],
  setSerializedProducts,
  setNonSerializedProducts,
  calculateInvoiceTotal,
  combinedTissueErrors = {},
  handleInputChange,
  shipDateDisabled = false,
  expirationDateDisabled = false,
  costDisabled = false,
  showTissueId = true,
  showExpirationDate = true,
  tissueIdDisabled,
}) => {
  const updateSerializedProduct = (index, values) => {
    const updated = [...serializedProducts];
    updated[index] = {
      ...updated[index],
      ...values,
    };
    setSerializedProducts(updated);
    return updated;
  };

  const updateNonSerializedProduct = (index, values) => {
    const updated = [...nonSerializedProducts];
    updated[index] = {
      ...updated[index],
      ...values,
    };
    setNonSerializedProducts(updated);
    return updated;
  };

  return (
    <>
      {serializedProducts.length > 0 && (
        <div className="modal-products-container">
          <Text variant="bodyText">Serialized Products</Text>
          <div className="field-group-wrapper">
            {serializedProducts.map((item, index) => (
              <div className="field-group" key={item.key}>
                <TextInput
                  titleText="Product Code"
                  placeholder="Product Code"
                  isRequired
                  value={item.ProductCode}
                  isDisabled
                />
                {showTissueId && (
                  <TextInput
                    titleText="Tissue ID"
                    placeholder="Tissue ID"
                    isRequired
                    value={item.TissueID}
                    isDisabled={
                      tissueIdDisabled !== undefined
                        ? tissueIdDisabled
                        : orderType === "Product Usage"
                    }
                    setValue={(val) => {
                      if (handleInputChange) {
                        handleInputChange(
                          { target: { value: val } },
                          item.key,
                          "TissueID"
                        );
                        return;
                      }

                      updateSerializedProduct(index, {
                        TissueID: val,
                      });
                    }}
                    errorText={combinedTissueErrors[item.key] || null}
                  />
                )}
                <TextInput
                  titleText="Cost"
                  placeholder="Cost"
                  isRequired
                  value={item.Price}
                  isDisabled={costDisabled}
                  setValue={(val) => {
                    const updated = updateSerializedProduct(index, {
                      Price: val,
                    });
                    calculateInvoiceTotal?.(updated, nonSerializedProducts);
                  }}
                />
                <DatePickerComponent
                  format="MM-DD-YYYY"
                  titleText="Ship Date"
                  isRequired
                  value={item.ShipDate}
                  isDisabled={shipDateDisabled}
                  onChange={(date) => {
                    updateSerializedProduct(index, {
                      ShipDate: date,
                    });
                  }}
                />
                {showExpirationDate && (
                  <DatePickerComponent
                    format="MM-DD-YYYY"
                    titleText="Expiration Date"
                    isRequired
                    value={item.ExpirationDate}
                    isDisabled={expirationDateDisabled}
                    onChange={(date) => {
                      updateSerializedProduct(index, {
                        ExpirationDate: date,
                      });
                    }}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      )}
      {nonSerializedProducts.length > 0 && (
        <div className="modal-products-container">
          <Text variant="bodyText">Non Serialized Products</Text>
          <div className="field-group-wrapper">
            {nonSerializedProducts.map((item, index) => (
              <div className="field-group" key={item.key}>
                <TextInput
                  titleText="Product Code"
                  placeholder="Product Code"
                  isRequired
                  value={item.ProductCode}
                  isDisabled
                />
                <TextInput
                  titleText="Cost"
                  placeholder="Cost"
                  isRequired
                  value={item.Price}
                  isDisabled={costDisabled}
                  setValue={(val) => {
                    const updated = updateNonSerializedProduct(index, {
                      Price: val,
                    });
                    calculateInvoiceTotal?.(serializedProducts, updated);
                  }}
                />
                <DatePickerComponent
                  format="MM-DD-YYYY"
                  titleText="Ship Date"
                  isRequired
                  value={item.ShipDate}
                  isDisabled={shipDateDisabled}
                  onChange={(date) => {
                    updateNonSerializedProduct(index, {
                      ShipDate: date,
                    });
                  }}
                />
                {showExpirationDate && (
                  <DatePickerComponent
                    format="MM-DD-YYYY"
                    titleText="Expiration Date"
                    isRequired
                    value={item.ExpirationDate}
                    isDisabled={expirationDateDisabled}
                    onChange={(date) => {
                      updateNonSerializedProduct(index, {
                        ExpirationDate: date,
                      });
                    }}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default InvoiceProductDetailsSection;
